<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-comments mr-1"></i> Pré-Comentários - Marcações no Corpo do Texto
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <div class="ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0">
                            <b-button variant="outline-primary" type="button" class="mr-2" v-b-modal.tutorial>
                                <i class="fas fa-play mr-1"></i>
                                Ver Tutorial
                            </b-button>

                            <!-- Create -->
                            <button type="button" class="btn btn-primary" v-b-modal.create>
                                Criar Comentário
                            </button>
                        </div>

                        <create :endpoint="endpointStore" @created="load"></create>

                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container">
            <!-- Filters -->
            <div class="row mb-2">
                <div class="col-sm-5">
                    <!-- Field -->
                    <b-form-group label="Nome do Atalho">
                        <b-form-input
                            v-model="filter.name"
                            placeholder="Buscar por nome do atalho do comentário ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-5">
                    <!-- Field -->
                    <b-form-group label="Conteúdo">
                        <b-form-input
                            v-model="filter.char"
                            placeholder="Buscar por conteúdo do comentário ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <b-card class="mb-4">
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                    <!-- Loading -->
                    <template #loading>
                        <b-skeleton-table
                            :rows="lastResultsCount"
                            :columns="3"
                            :table-props="{ bordered: true, striped: false }"
                        >
                        </b-skeleton-table>
                    </template>

                    <!-- Table -->
                    <b-table
                        id="preCommentTable"
                        :items="table"
                        :fields="fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="changeSortable"
                        empty-text="Não encontramos nenhum resultado na busca :("
                        class="bg-white mb-0"
                        stacked="md"
                        :sticky-header="true"
                        show-empty
                        no-local-sorting
                        bordered
                        hover>

                        <template v-slot:cell(name)="row">
                            <span class="font-weight-bold">
                                /{{ row.item.name }}
                            </span>
                        </template>

                        <template v-slot:cell(char)="row">
                            <i class="fas fa-comment mr-1"></i>
                            {{ row.item.char | truncate(50) }}
                        </template>

                        <template v-slot:cell(created_at)="row">
                            {{ row.item.created_at | moment('from', 'now') }}
                        </template>

                        <template v-slot:cell(updated_at)="row">
                            {{ row.item.updated_at | moment('from', 'now') }}
                        </template>

                        <template v-slot:cell(actions)="row">
                            <div class="text-center">

                                <!-- Details -->
                                <a href="#" @click="showDetail(row.item)" v-b-tooltip.hover title="Detalhes do Comentário">
                                    <i class="fas fa-eye"></i>
                                </a>

                            </div>
                        </template>

                    </b-table>
                </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <!-- Results -->
            <div class="">
                {{ total }} resultados encontrados.
            </div>

        </div>

        <!-- Show -->
        <show :endpoint-update="endpointUpdate" :endpoint-destroy="endpointDestroy" @load="load"></show>

        <!-- Tutorial -->
        <b-modal id="tutorial" title="Tutorial" size="xl" cancel-title="Fechar" ok-title="Entendi :)">
            <div class="my-4">
                <video src="/videos/tutorial-pre-comentarios.mp4" width="100%" controls>
                </video>
            </div>
        </b-modal>

    </div>
</template>

<script>
import Create from "./Create";
import Show from './Show';

export default {
    components: {
        Create,
        Show,
    },
    props: ['endpointIndex', 'endpointStore', 'endpointUpdate', 'endpointDestroy'],
    data() {
        return {
            loading: false,
            table: [],
            perPage: 9,
            currentPage: 1,
            total: 0,
            sortBy: 'name',
            sortDesc: false,
            fields: [
                { key: 'name', label: 'Atalho do Comentário', sortable: true },
                { key: 'char', label: 'Conteúdo do Comentário', sortable: true },
                { key: 'created_at', label: 'Adicionada', sortable: true },
                { key: 'actions', label: '' }
            ],
            filter: {
                name: null,
                char: null
            },
            lastResultsCount: 5
        }
    },
    created() {
        this.load()
    },
    watch: {
        'filter.name': async function (value) {
            this.filter.name = await value;
            await this.load()
        },
        'filter.char': async function (value) {
            this.filter.char = await value;
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    name: this.filter.name,
                    char: this.filter.char,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.preComments.data
                    this.currentPage = response.preComments.current_page
                    this.perPage = response.preComments.per_page
                    this.total = response.preComments.total

                    this.lastResultsCount = response.preComments.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        showDetail(preComment) {
            this.$root.$emit('preCommentShowDetail', preComment)
        },

    }
}
</script>

<style scoped>

</style>
